import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { SplitText } from "gsap/SplitText";

gsap.registerPlugin(ScrollTrigger, ScrollSmoother, SplitText);

// Testimonial text colour reveal
const splitTypes = document.querySelectorAll(".js-reveal-testimonial");

if (splitTypes) {
    splitTypes.forEach((char, i) => {
        const text = new SplitText(char, { type: "chars, words" });
        
        gsap.from(text.chars, {
            scrollTrigger: {
                trigger: char,
                start: "top 75%",
                end: "top 20%",
                scrub: true,
            },
            opacity: 0.25,
            stagger: 0.1,
        });
    });
}

// Number increment
const ourImpactSection = document.querySelector('[data-block="our-impact"]');
const counters = document.querySelectorAll('[data-count-start]');

if (ourImpactSection) {
    ScrollTrigger.create({
        trigger: ourImpactSection,
        start: '-25% center',
        once: true,
        onEnter: () => {
            counters.forEach((counter) => {
                const endValue = parseFloat(counter.getAttribute('data-count-end'));
                
                gsap.fromTo(counter, 
                    { innerText: 0 }, 
                    { 
                        innerText: endValue, 
                        duration: 3, 
                        snap: { innerText: 0.1 }, 
                        ease: 'power1.inOut', 
                        onUpdate: () => {
                            counter.innerText = parseFloat(counter.innerText).toLocaleString();
                        } 
                    }
                );
            });
        },
    });
}

// Borders
let borders = document.querySelectorAll('.js-border-reveal');

if (borders) {
    borders.forEach((border) => {
        ScrollTrigger.create({
            trigger: border,
            start: '-=150px center',
            once: true,
            onEnter: () => {
                gsap.fromTo(border, { width: '0' }, { width: '100%', duration: 1.5, ease: 'power4.out' });
            },
        });
    });
}